import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cbe85b44"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mt--20 container content center heightContent"
}
const _hoisted_2 = {
  key: 1,
  class: "offer-card"
}
const _hoisted_3 = { class: "container content offer-card__container" }
const _hoisted_4 = { class: "only-mobile" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "underline main-color" }, "Назад", -1))
const _hoisted_6 = { class: "content__title offer-card__container-title" }
const _hoisted_7 = {
  key: 0,
  class: "font-size-title-block mr--5"
}
const _hoisted_8 = {
  key: 2,
  class: "font-size-title-block mr--5"
}
const _hoisted_9 = { key: 0 }

import { useRoute } from 'vue-router';
import { computed, onMounted, onUnmounted, Ref, ref, watch } from 'vue';
import { FileType, ResultCardType } from '@/types';
import { OfferCard } from '@/components/Cards';
import { useOfferCardsStore } from '@/store/modules/offerCards';
import { useUserStore } from '@/store/modules/user';
import { usePartnerProgramStore } from '@/store/modules/partnerProgram';
import { PartnersFilesModal } from '@/components';
import { useAppStore } from '@/store/modules/app';
import { errorHandle } from '@/utils/Common/Common';

type PartnersFilesModalDataType = {
  cardId: number | undefined;
  show: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'OfferCardPageLayout',
  setup(__props) {

const offerCardData: Ref<ResultCardType | undefined> = ref(undefined);
const loading = ref(false);

const commission: Ref<number | undefined> = ref(undefined);
const partnerFiles: Ref<FileType[]> = ref([]);
const partnersFilesModalData: Ref<PartnersFilesModalDataType> = ref({
  cardId: undefined,
  show: false,
});

const title = computed((): string => {
  if (offerCardData.value) {
    if (offerCardData.value.id === offerCardData.value.landId) {
      return `${offerCardData.value.name || '-'} | ${offerCardData.value.landArea || '-'} сот. | ${offerCardData.value.address || '-'}`;
    }

    return `${offerCardData.value.name || '-'} | ${offerCardData.value.houseArea || '-'} м² | ${offerCardData.value.address || '-'}`;
  }

  return 'Название';
});

const changeIsFavorite = async (cardId: number) => {
  await useUserStore().changeIsFavorite(cardId);
};

const showPartnersFiles = (cardId: number) => {
  partnersFilesModalData.value.cardId = cardId;
  partnersFilesModalData.value.show = true;
};

const closePartnersFilesModal = () => {
  partnersFilesModalData.value.cardId = undefined;
  partnersFilesModalData.value.show = false;
};
const route = useRoute();

const cardUrl = computed((): string => {
  if (Array.isArray(route.params.url)) {
    return route.params.url[0];
  }

  return route.params.url;
});

const getCardInfo = async () => {
  if (cardUrl.value) {
    loading.value = true;
    try {
      const res = await useOfferCardsStore().searchOfferCardByUrl(cardUrl.value);

      if (res) {
        offerCardData.value = res;

        if (offerCardData.value?.affiliateProgramId) {
          commission.value = await usePartnerProgramStore().getCommissionById(
            offerCardData.value?.affiliateProgramId,
          );

          const files = await usePartnerProgramStore().getPartnerDocsById(
            offerCardData.value?.affiliateProgramId,
          );

          if (files) {
            partnerFiles.value = files.map(el => {
              return {
                ...el,
                path: `${useAppStore().baseUrl}${process.env.VUE_APP_API_AFFILIATE_PROGRAM_DOWNLOAD_ONE_FILE}?id=${el.id}`,
              };
            });
          }
        }
      }
    } catch (error) {
      errorHandle(error);
    } finally {
      loading.value = false;
    }
  } else {
    useAppStore().togglePageNotFound(true);
  }
};

onMounted(async () => {
  if (useAppStore().getWindowWidth() < 960) {
    document.documentElement.style.setProperty('--btn-up-bottom', '120px');
  }
  await getCardInfo();
});

watch(
  () => cardUrl.value,
  () => {
    getCardInfo();
  },
);

onUnmounted(() => {
  document.documentElement.style.removeProperty('--btn-up-bottom');
});

return (_ctx: any,_cache: any) => {
  const _component_base_spinner = _resolveComponent("base-spinner")!
  const _component_base_icon = _resolveComponent("base-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (loading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_base_spinner, {
          size: 50,
          color: "#009D3E"
        })
      ]))
    : (offerCardData.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                class: "items-in-line flex-start mt--25 gap--5 pl--20",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
              }, [
                _createVNode(_component_base_icon, {
                  color: "#009D3E",
                  name: "arrow_back"
                }),
                _hoisted_5
              ])
            ]),
            _createElementVNode("h1", _hoisted_6, [
              _createTextVNode(_toDisplayString(title.value) + " ", 1),
              (offerCardData.value.aboutDeveloper)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "|"))
                : _createCommentVNode("", true),
              (offerCardData.value.aboutDeveloper)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: { name: 'developer', params: { url: offerCardData.value.aboutDeveloper?.url } },
                    class: "gradient-color"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("СК ")
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : _createCommentVNode("", true),
              (offerCardData.value.aboutResidentialComplex)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "|"))
                : _createCommentVNode("", true),
              (offerCardData.value.aboutResidentialComplex)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 3,
                    to: {
            name: 'residentialComplex',
            params: { url: offerCardData.value.aboutResidentialComplex?.url },
          },
                    class: "gradient-color"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("ЖК ")
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : _createCommentVNode("", true)
            ]),
            (offerCardData.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_unref(OfferCard), {
                    commission: commission.value,
                    offerCard: offerCardData.value,
                    partnerFiles: partnerFiles.value,
                    onChangeIsFavorite: changeIsFavorite,
                    onShowPartnersFiles: showPartnersFiles
                  }, null, 8, ["commission", "offerCard", "partnerFiles"])
                ]))
              : _createCommentVNode("", true),
            (offerCardData.value?.affiliateProgramId)
              ? (_openBlock(), _createBlock(_unref(PartnersFilesModal), {
                  key: 1,
                  "partner-program-id": offerCardData.value?.affiliateProgramId,
                  partnerFiles: partnerFiles.value,
                  "show-modal": partnersFilesModalData.value.cardId,
                  onClose: closePartnersFilesModal
                }, null, 8, ["partner-program-id", "partnerFiles", "show-modal"]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
}
}

})